import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {DatePipe} from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {ProductPriority} from '../../../../../models/product-priority/product-priority';
import {RouterLink} from '@angular/router';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {ProductPriorityService} from '../../../../../services/product-priority/product-priority.service';
import {ProductPriorityProduct} from '../../../../../models/product-priority/product-priority-product';

@Component({
  selector: 'app-product-priority-list',
  imports: [
    ConfirmDirective,
    IsGrantedDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    RouterLink,
    TableSorterDirective,
    DatePipe
  ],
  templateUrl: './product-priority-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-priority-list.component.scss'
})
@IsGranted(['PRODUCT_PRIORITY_VIEW'])
@MetaTitle('Products priority list')
export class ProductPriorityListComponent implements OnInit {
  productPriorities: ProductPriority[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private productPriorityService: ProductPriorityService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.productPriorityService.findAll({groups: 'product'}, this.paginator, this.tableSorter).subscribe((productPriorities) => {
      this.productPriorities = productPriorities;

      this.loader.stopLoading();
    })
  }

  delete(productPriority: ProductPriority): void {
    if (productPriority.id) {
      this.loader.startLoading();
      this.productPriorityService.delete(productPriority.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Product priority list has been deleted');
        this.fetchAll();
      });
    }
  }

  getSortedProducts(productPriority: ProductPriority): string {
    return productPriority.products.map((productPriorityProduct: ProductPriorityProduct) =>
      productPriorityProduct.product?.name
    ).join(', ');
  }
}
